<ng-template #templateRef>
    <form #editorForm="ngForm" name="editAccount" (ngSubmit)="save()" id="accountEditor">
        <h2 mat-dialog-title>{{Copy && Copy.Id ? 'Edit' : 'New'}} data entry</h2>
        <mat-dialog-content *ngIf="Copy">
            <div class="row">
                <div class="col-12">
                    <app-account-selector name="Account" [(ngModel)]="Copy.Account" required></app-account-selector>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <app-article-selector name="Article" [(ngModel)]="Copy.Article" required></app-article-selector>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <app-dropdown-option name="Type" placeholder="Type" model="ActivationArticle" discriminator="Type" [(ngModel)]="Copy.Type" required></app-dropdown-option>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <mat-form-field>
                      <mat-label>Amount</mat-label>
                        <input type="number" matInput name="Amount" [(ngModel)]="Copy.Amount" required>
                    </mat-form-field>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <div class="fill-remaining-space"></div>
            <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
            <button type="button" mat-button mat-raised-button (click)="save(this.Copy, true)">Save & Next</button>
            <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
        </mat-dialog-actions>
    </form>
</ng-template>
